import { create } from "zustand";

interface WindowState {
	terminalOpen: boolean;
	setTerminalOpen: (value: boolean) => void;
	filePickerOpen: boolean;
	setFilePickerOpen: (value: boolean) => void;
}

export const useWindowStore = create<WindowState>()((set) => ({
	terminalOpen: true,
	setTerminalOpen: (value: boolean) => set({ terminalOpen: value }),
	filePickerOpen: true,
	setFilePickerOpen: (value: boolean) => set({ filePickerOpen: value }),
}));
